
























































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  RimRepairLayoutComponent,
  RimRepairModalComponent,
} from "@/components/common";
import {
  IInvoice,
  ICustomer,
  IInvoiceData,
  ISearchInvoicesData,
  INotifyInvoiceRequest,
  ISearchInvoicesRequest,
  PostToQuickbooksRequest,
  InvoiceStatus,
	ResetInvoiceStatusRequest,
  DialogConfig,
  IWhoAmI,
} from "@/interfaces";
import {
  GetInvoices,
  GetCustomer,
  VoidInvoice,
  InvoiceBegin,
  NotifyInvoice,
  PostToQuickbooks,
  ResetInvoiceStatus,
} from "@/api";
import { DataTableHeader } from "vuetify";
import CustomerCard from "./customer-card.vue";
import { formatDate, formatFromUtcDate, makeInvoice, makeInvoiceData } from "@/utils";
import SubmitInvoiceComponent from "./submit-invoice.vue";
import StatusFilter from "./status-filter.vue";
import InvoiceSearchFilters from "./invoice-search-filters.vue";
import { UserInterface } from "../../../utils/UserInterface";
import { Getter } from "vuex-class";
import { HELPER } from "@/utils/Helper";
import { BASE_URL } from "@/plugins/axios";

@Component({
  components: {
    RimRepairLayoutComponent,
    RimRepairModalComponent,
    CustomerCard,
    SubmitInvoiceComponent,
    StatusFilter,
    InvoiceSearchFilters,
  },
})
export default class InvoicesControllerComponent extends Vue {
 
  public invoices: IInvoiceData[] = [];
  public loading = false;
	public MultiplePost: string[] = [];

  public CurrPage: number = 0;
  public PageSize: number = 5;
  public TotalPages: number = 0;


	public get headers():DataTableHeader[]{
	
	  var rval : DataTableHeader[] = [
    {
      text: "Invoice Number",
      value: "InvoiceNumber",
    },
    { text: "Date", value: "date", sortable: false },
    {
      text: "Customer",
      value: "CustomerName",
    },
		];

		if (this.Settings.IsController){
				rval.push({ text: "Payment Type", value: "paytype", sortable: false });
		}

		rval.push(
    { text: "Total", value: "total", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "", value: "customer", sortable: false },
    { text: "", value: "edit", sortable: false },
    { text: "", value: "details", sortable: false },
    { text: "", value: "post", sortable: false },
    { text: "", value: "resend", sortable: false },
    { text: "", value: "print", sortable: false },
    { text: "", value: "reset", sortable: false },
    { text: "", value: "void", sortable: false },
	);

	return rval;
	}




  // Customer dialog
  public customerDialog = false;
  public customer: ICustomer = null;
  public customerLoading = false;

  public ShouldResend: boolean = false;
  public ResendingInvoice: IInvoiceData = makeInvoiceData({});

  public SearchRequest: ISearchInvoicesRequest = new ISearchInvoicesRequest();

  public Settings: SectionSettings = new SectionSettings();

  private UI__: UserInterface = new UserInterface(this);


  @Getter("getTimestampInvoices", { namespace: "AppModule" })
  private getTimestampInvoices: string;

  @Watch("getTimestampInvoices")
  onValueChanged(newVal: any, oldVal: any) {
		/// WE ARE WATCHING A VUEX VARIABLE THAT TELLS 
		/// IF THE USERS CHANGED, IN WHICH CASE WE SHOULD
		/// TRIGGER A NEW SEARCH.
		this.CurrPageChanged();
	}





  created() {
	}

  mounted() {
		this.Initializations();
	}
	
	private Initializations(){
    this.Settings = this.ConfigureSection();
		
		this.SearchRequest.InvoiceStatus = [this.Settings.DefaultSearchStatus];
		this.SearchRequest.TechID = this.Settings.DefaultTechnician;
		this.SearchRequest.PageSize = 5;
		this.SearchRequest.MinDate = null;
		this.SearchRequest.MaxDate = null;

		var prevState = this.LoadState();

		if (prevState!=null)
			this.SearchRequest= prevState;

		this.LoadInvoices(0);
	}


private GetStoreName():string{
	var rval: string = this.isController
	?"Invoice-Search:inv-controller"
	:"Invoice-Search:inv-tech";
	return rval;
}


private LoadState():any{
		var prevState = HELPER.Restore(this.GetStoreName());
		return prevState;
}



  /* VUE COMPUTED METHODS */
  get isController(): boolean {
		var isIt = this.$route.meta.IsController;
		return isIt;
  }




  @Watch("$route.meta.IsController")
	RouteChanged(isController:boolean, wasController:boolean){
		/*
		WHEN WE GO FROM "invoices" TO "invoices-controller" ROUTES, 
		THE COMPONEND DOESN'T ACTUALLY CHANGE, THEREFORE THERE IS NO REFRESH
		OF DATA (WE NEED THIS REFRESH OF DATA).

		TO ADDRESS THIS ISSUE, WE WATCH ON A META-PROPERTY THAT WE CREATED
		ON THE ROUTE, SO IF WE SPOT A CHANGE ON THIS PROPERTY, WE RELOAD
		AND SET BACK UP A FEW VALUES SO IT DISPLAYS PROPERLY. 

		THE EXCEPTION IS IF WE HAVE AN UNDEFINED VALUE, 
		IN WHICH CASE WE SHOULDN'T TRIGGER INITIALIZATIONS, 
		BECAUSE TRIGGERING INITIALIZATIONS, JACKS
		WITH THE STATE OF THE COMPONENT WHEN 
		WE RETURN BACK TO IT. 
		*/
		if (isController==undefined || wasController == undefined)
			return;


		this.Initializations();
	}


  async LoadInvoices(fromPage: number) {
    this.loading = true;

    this.CurrPage = fromPage;

    let page = this.CurrPage - 1 > 0 ? this.CurrPage - 1 : 0;

    var req = this.SearchRequest;
    req.Page = page;

    this.UI__.TurnBlockerOn();

    let resp = await GetInvoices(req);

    if (resp.Ok) {
      this.invoices = resp.Results.Invoices;

      this.CurrPage = resp.Results.Page + 1;
      this.PageSize = resp.Results.PageSize;
      this.TotalPages = resp.Results.MaxPage + 1;

      this.loading = false;

			this.MultiplePost = [];
    }

    this.UI__.TurnBlockerOff();
  }

  formatDate(date: string) {
    return formatFromUtcDate(date, "MM/dd/yyyy");
  }

  async viewCustomer(invoice: IInvoiceData) {
    this.customerDialog = true;
    this.customerLoading = true;
    const resp = await GetCustomer(+invoice.CustomerID!);
    this.customerLoading = false;
    this.customer = resp.Customer;
  }

  public GetStatus(i: IInvoiceData): string {
    let s = "-- unknown --";

    switch (i.Status) {
      case InvoiceStatus.Any:
        break;

      case InvoiceStatus.ReadyToPost:
        s = "Ready to Post";
        break;

      case InvoiceStatus.Posted:
        s = "Posted";
        break;
      case InvoiceStatus.Draft:
        s = "Draft";
        break;
      case InvoiceStatus.Voided:
        s = "Voided";
        break;
    }

    return s;
  }

  public GetStatusColor(i: IInvoiceData): string {
    let s = "default";

    switch (i.Status) {
      case InvoiceStatus.Any:
        break;

      case InvoiceStatus.ReadyToPost:
        s = "info";
        break;

      case InvoiceStatus.Posted:
        s = "success";
        break;
      case InvoiceStatus.Draft:
        s = "primary";
        break;
      case InvoiceStatus.Voided:
        s = "error";
        break;
    }

    return s;
  }

  viewDetails(invoice: IInvoiceData) {
    this.$router.push(`${this.Settings.ViewLinkPrefix}/${invoice.InvoiceNumber}`);
  }

  edit(invoice: IInvoiceData) {
		var prefixPath = this.Settings.EditLinkPrefix;
    this.$router.push(`${prefixPath}/${invoice.InvoiceNumber}`);
  }

  public BeginVoidInvoice(invoice: IInvoiceData): void {
    this.UI__.QuickConfirm(
      "Confirm VOID Invoice",
      "Are you sure you want to VOID the selected Invoice ?",
      (ok) => {
        if (!ok) return;
        this.VoidInvoiceGo(invoice);
      }
    );

    // this.voidDialog = true;
    // this.invoice = invoice;
  }

  public async VoidInvoiceGo(invoice: IInvoiceData) {
    this.UI__.TurnBlockerOn();

    const resp = await VoidInvoice(invoice.InvoiceNumber!);

    this.UI__.TurnBlockerOff();

    if (!resp.Ok) return;

    invoice.Status = InvoiceStatus.Voided;

    this.UI__.SnacSuccess("Invoice successfully VOIDED");
  }

  public FiltersUpdated(): void {
		/// PRESERVING THE SEARCH CONFIGURATION.
		HELPER.Preserve(this.GetStoreName(), this.SearchRequest);

    this.LoadInvoices(0);
  }

  public CurrPageChanged(): void {
    this.LoadInvoices(this.CurrPage);
  }

  public async BeginInvoice() {
    this.UI__.TurnBlockerOn();

    let resp = await InvoiceBegin();

    this.UI__.TurnBlockerOff();

    if (!resp.Ok) {
      /* DON'T ALLOW TO CONTINUE IF THERE IS AN ERROR. */
      return;
    }

    this.$router.push(`${this.Settings.EditLinkPrefix}/${resp.InvoiceNumber}`);
  }


private _printIframe: any;
	public BeginPrint(invoice: IInvoiceData): void {

		var url = BASE_URL+'?action=print-invoice&inv='+invoice.InvoiceNumber;

		window.open(BASE_URL+'?action=print-invoice&inv='+invoice.InvoiceNumber)

		/*
			THE FOLLOWING SNIPPET CAN PRINT A PDF WITHOUT GOING VIA
			A BROWSER TAB. 
			SOURCE 
			https://stackoverflow.com/questions/16239513/print-pdf-directly-from-javascript
		*/
		// var iframe = this._printIframe;
		// if (!this._printIframe) {
		// 	iframe = this._printIframe = document.createElement('iframe');
		// 	document.body.appendChild(iframe);

		// 	iframe.style.display = 'none';
		// 	iframe.onload = function() {
		// 		setTimeout(function() {
		// 			iframe.focus();
		// 			iframe.contentWindow.print();
		// 		}, 1);
		// 	};
		// }

		// iframe.src = url;
	}

  public BeginResend(invoice: IInvoiceData): void {
    this.ResendingInvoice = invoice;
    this.ShouldResend = true;
  }

  public async Resend(emails: string[], message: string) {
    var req: INotifyInvoiceRequest = {
      InvoiceNumber: this.ResendingInvoice.InvoiceNumber,
      Recipients: emails,
			MessageForCustomer: message
    };

    this.UI__.TurnBlockerOn();

    let resp = await NotifyInvoice(req);

    this.UI__.TurnBlockerOff();

    if (!resp.Ok) return;

    this.ShouldResend = false;

    this.UI__.SnacSuccess("Invoice successfully sent to: " + emails.join(", "));


		/* MANUALLY ADDING A DATE SO THE USER 
		GETS THIS FEEDBACK. ALTHOUGH THE REAL DATE WILL 
		BE STAMPED ON THE SERVER.
		 */

		/*
		NEED TO MAKE SOME TZ ADJUSTMENTS, BECAUSE
		LOCALLY WE GET A LOCAL TZ INSTEAD OF AN UTC TZ, AND THE 
		DATES ARE FORMATTING AS IF THEY WERE UTC (AS STORED ON THE SERVER),
		THEREFORE WE NEED TO ADJUST THIS LOCAL DATE TO BECOME UTC, 
		BEFORE ASSIGNING IT TO THE OBJECT.
		*/
		var tzOffset = new Date().getTimezoneOffset();
		var modDate: Date = new Date(new Date().getTime()  + (60000 * tzOffset) ); 

		this.ResendingInvoice.LastTimeMailed = modDate.toISOString() as any;

  }


  public BeginPostToQuickBooks(invoice: IInvoiceData): void {

		var iof = this.MultiplePost.indexOf(invoice.InvoiceNumber);
		if (iof==-1){
			/* MAKE SURE THAT CLICKING THIS BUTTON ALSE SELECTS THE ITEM FOR POSTING. */
			this.MultiplePost.push(invoice.InvoiceNumber);
		}

		var invoices = this.MultiplePost.join(', ');
		var plural = this.MultiplePost.length==1?"": "s";

    this.UI__.QuickConfirm(
      "Confirm Post to Quickbooks",
      `Are you sure you want to POST to Quickbooks Invoice${plural} ${invoices} ?`,
      (ok) => {
        if (!ok) return;
        this.PostToQuickBooks(invoice);
      }
    );
  }


  public async PostToQuickBooks(invoice: IInvoiceData) {
    var req: PostToQuickbooksRequest = new PostToQuickbooksRequest();
		req.InvoiceNumbers = this.MultiplePost;

    this.UI__.TurnBlockerOn();

    let resp = await PostToQuickbooks(req);

    this.UI__.TurnBlockerOff();

    if (!resp.Ok) return;

		var invoices = this.MultiplePost.join(', ');
		var plural = this.MultiplePost.length==1?"": "s";

    this.UI__.SnacSuccess(`Invoice${plural} ${invoices} successfully Posted to Quickbooks`);

		this.MultiplePost.forEach(e => {
			var match = this.invoices.filter(i=> i.InvoiceNumber==e)[0];
			match.Status = InvoiceStatus.Posted;
		});

		this.MultiplePost = [];
  }


  public BeginResetToDraft(invoice: IInvoiceData): void {
      this.ResetStatus(invoice, InvoiceStatus.Draft, 'Draft');
	}

  public BeginResetToReadyToPost(invoice: IInvoiceData): void {
      this.ResetStatus(invoice, InvoiceStatus.ReadyToPost, 'Ready to Post');
	}



  public BeginReset(invoice: IInvoiceData): void {
    this.UI__.QuickConfirm(
      "Confirm Reset",
      "Are you sure you want to RESET the selected Invoice ?",
      (ok) => {
        if (!ok) return;
        this.ResetStatus(invoice, InvoiceStatus.ReadyToPost, 'Ready to Post');
      }
    );
  }

  public async ResetStatus(invoice: IInvoiceData, s: InvoiceStatus, str: string) {
    var req: ResetInvoiceStatusRequest = {
      InvoiceNumber: invoice.InvoiceNumber,
			Status: s,
    };

    this.UI__.TurnBlockerOn();

    let resp = await ResetInvoiceStatus(req);

    this.UI__.TurnBlockerOff();

    if (!resp.Ok) return;

    this.UI__.SnacSuccess(`Invoice successfully Reset to ${str} !`);

    invoice.Status = s;
  }

  private ConfigureSection(): SectionSettings {

    var isController = this.$route.meta.IsController;

    var rval = new SectionSettings();

		var self= (this.$store.getters["AppModule/user"] as IWhoAmI);
		var myself:number = self.UserID; 
			
		var isAdmin = self.Roles.includes(30);

		if (isController) {
      rval.PageTitle = "Invoices Controller";
			rval.EditLinkPrefix = "/invoices-controller/edit";
			rval.ViewLinkPrefix = "/invoices-controller";
      rval.CanPost = true;
      rval.CanResend = true;
      rval.CanVoid = true;
			rval.CanReset = true;
			rval.IsController = true;
			rval.DefaultSearchStatus = InvoiceStatus.ReadyToPost;
			rval.CanEditDraft = true;
			rval.CanEditReady = true;
			rval.DefaultTechnician = null;
			rval.TechnicianDropdown = true;
			rval.CanPrint = true;
    } else {
      rval.PageTitle = "Invoices";
      rval.EditLinkPrefix = "/invoices/edit";
			rval.ViewLinkPrefix = "/invoices";
      rval.CanPost = false;
      rval.CanResend = true;
      rval.CanVoid = false;
      rval.CanReset = false;
			rval.IsController = false;
			rval.DefaultSearchStatus = InvoiceStatus.Draft;
			rval.CanEditDraft = true;
			rval.CanEditReady = false;
			rval.DefaultTechnician = myself;

			/* SHOW THE TECH DROPDOWN IF THE TECH IS AN ADMIN AS WELL */
			rval.TechnicianDropdown = isAdmin;// false;

			rval.CanPrint = false;
		}

    return rval;
  }


	public FormatDate(v?: string):string{
		if (!v)return '';
		return formatFromUtcDate(v, "MM/dd/yy h a");
	}

}

class SectionSettings {
  PageTitle: string;
  EditLinkPrefix: string;
  ViewLinkPrefix: string;
  CanPost: boolean;
  CanResend: boolean;
  CanVoid: boolean;
  CanReset: boolean;
  IsController: boolean;
  DefaultSearchStatus: InvoiceStatus;
  CanEditDraft: boolean;
  CanEditReady: boolean;
  DefaultTechnician: number;
  TechnicianDropdown: boolean;
	CanPrint: boolean;
}
